module.exports = __webpack_public_path__ + "static/media/flag-kk.65566ca9.webp";